import PropTypes from 'prop-types';

export const validTypeValues = ['success', 'info', 'warning', 'error'] as const;
export type typeValues = (typeof validTypeValues)[number];

export const validVariationValues = ['loud', 'soft'] as const;
export type variationValues = (typeof validVariationValues)[number];

export const validBackgroundValues = ['white', 'light'] as const;
export type backgroundValues = (typeof validBackgroundValues)[number];

export interface AlertProps {
  type: typeValues;
  variation?: variationValues;
  background?: backgroundValues;
  title?: React.ReactNode;
  fullWidth?: boolean;
  children?: React.ReactNode;
  [key: string]: unknown;
}

interface AlertWithTitle extends AlertProps {
  title: React.ReactNode;
}

interface AlertWithChildren extends AlertProps {
  children: React.ReactNode;
}

export type AlertType = AlertWithTitle | AlertWithChildren | (AlertWithTitle & AlertWithChildren);

export const AlertPropTypes = {
  type: PropTypes.oneOf(validTypeValues).isRequired,
  variation: PropTypes.oneOf(validVariationValues),
  background: PropTypes.oneOf(validBackgroundValues),
  title: PropTypes.node,
  children: PropTypes.node,
  fullWidth: PropTypes.bool
};
